import { createApp } from "vue"; // Vue 앱 인스턴스 생성
import App from "./App.vue";
import router from "@/router"; // 라우터 등록
import vuetify from "@/common/plugins/vuetify"; // Vuetify 플러그인
import i18n from "@/i18n"; // 다국어(i18n) 설정
import global from "@/common/plugins/global"; // 전역 헬퍼/프로퍼티
import { createPinia } from "pinia"; // Pinia
import piniaPlugin from "pinia-plugin-persistedstate"; // Pinia 상태 영속 플러그인
import { setAxios } from "@/common/api/Axios.ts"; // Axios 설정
import EasyDataTable from "@/common/plugins/easyTable"; // table 컴포넌트
import purifyPlugin from "@/common/plugins/dompurify"; // DOMPurify 플러그인 (XSS)

// 베이스 컴포넌트 객체
import { Base } from "@/common/base-components/BaseFactory.ts";

// 어드민 베이스 컴포넌트
import BaseBreadcrumb from "@/components/base/BaseBreadcrumb.vue";
import BaseCard from "@/components/base/BaseCard.vue";
import BaseSearch from "@/components/base/BaseSearch.vue";
import BaseTable from "@/common/base-components/admin/BaseTable.vue";

// 전역 스타일(Scss)
import "@/assets/scss/style.scss"; // 전역 스타일
import "@/assets/default.css"; // 공통 CSS
// router navigation
import { navigationGuard } from "@/router/NavigationGuard.ts";

// Pinia 인스턴스 생성
const pinia = createPinia(); // Pinia 스토어 생성
pinia.use(piniaPlugin); // 상태 영속화 플러그인 적용

// 앱 인스턴스 생성 및 전역 컴포넌트/플러그인 등록
const app = createApp(App); // 앱 생성

// 전역 컴포넌트 등록
app.component("BaseInput", Base.Input);
app.component("BaseButton", Base.Button);
app.component("VEasyTable", EasyDataTable);
app.component("BaseBreadcrumb", BaseBreadcrumb);
app.component("BaseCard", BaseCard);
app.component("BaseSearch", BaseSearch);
app.component("BaseTable", BaseTable);

// 전역 플러그인 사용
app.use(purifyPlugin); // DOM 정화 플러그인 등록
app.use(pinia); // Pinia 등록
app.use(setAxios); // Axios 인터셉터/기본설정 등록
app.use(i18n); // i18n 등록
app.use(global); // 전역 헬퍼/프로퍼티 등록
app.use(router); // 라우터 등록 (라우트 사용 가능)
app.use(vuetify); // Vuetify UI 프레임워크 적용

// 앱 마운트 및 네비게이션 가드 초기화
app.mount("#app"); // DOM에 앱 마운트
navigationGuard(router); // 라우팅 가드 등록/초기화
